export default "__VITE_ASSET__CUJ9NfAb__"